// Shared PDP and basket estimates: London cut-off, working days and configured closures.
globalThis.TFFCDelivery = Object.freeze({
    window(now, minDays, maxDays, cutoff, excluded = []) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now).map((part) => [part.type, part.value]));
      const base = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const holidays = new Set(excluded);
      const working = (date) => date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !holidays.has(date.toISOString().slice(0, 10));
      if (Number(parts.hour) >= cutoff) base.setUTCDate(base.getUTCDate() + 1);
      while (!working(base)) base.setUTCDate(base.getUTCDate() + 1);
      const advance = (days) => {
        const date = new Date(base);
        for (let count = 0; count < days;) {
          date.setUTCDate(date.getUTCDate() + 1);
          if (working(date)) count++;
        }
        return date;
      };
      return [advance(Math.max(0, minDays)), advance(Math.max(minDays, maxDays))];
    },

    saturday(now, cutoff, excluded = []) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now).map(part => [part.type, part.value]));
      const date = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const day = date.getUTCDay();
      if (!(day === 4 && Number(parts.hour) >= cutoff || day === 5 && Number(parts.hour) < cutoff)) return null;
      date.setUTCDate(date.getUTCDate() + 5 - day);
      if (excluded.includes(date.toISOString().slice(0, 10))) return null;
      date.setUTCDate(date.getUTCDate() + 1);
      return excluded.includes(date.toISOString().slice(0, 10)) ? null : date;
    },

    orderBy(now, cutoff, excluded, message) {
      const [dispatch] = this.window(now, 0, 0, cutoff, excluded);
      if (dispatch.toLocaleDateString('en-GB', { timeZone: 'UTC' }) === now.toLocaleDateString('en-GB', { timeZone: 'Europe/London' })) return message;
      const weekday = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'UTC' }).format(dispatch);
      return `${message} ${weekday}`;
    },

    format(start, end) {
      const formatter = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
      const parts = date => Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
      const first = parts(start);
      const last = parts(end);
      const sameYear = start.getUTCFullYear() === end.getUTCFullYear();
      const sameMonth = sameYear && start.getUTCMonth() === end.getUTCMonth();
      const finish = `${last.weekday} ${last.day} ${last.month}`;
      if (start.getTime() === end.getTime()) return finish;
      const begin = `${first.weekday} ${first.day}${sameMonth ? '' : ` ${first.month}`}`;
      return sameYear ? `${begin} – ${finish}` : `${begin} ${start.getUTCFullYear()} – ${finish} ${end.getUTCFullYear()}`;
    }

});
